/* eslint-disable import/prefer-default-export */
export const tagsToOptions = (tags) =>
  tags.map((tag) => ({
    name: tag.name,
    id: tag.id,
  }))
